// console.log("Ready to rendre")

// class CustomSlider extends HTMLElement {
//     constructor() {
//       super();
  
//       const shadowRoot = this.attachShadow({ mode: 'open' });
//       const template = document.createElement('template');
//       template.innerHTML = `
//         <style>
//           .card-slider {
//             position: relative;
//             width: 100%;
//             overflow: hidden;
//           }
  
//           .cards-container {
//             display: flex;
//             transition: transform 0.3s ease-in-out;
//           }
  
//           .card {
//             flex: 0 0 300px;
//             height: 200px;
//             background-color: #f0f0f0;
//             margin: 10px;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             font-size: 24px;
//           }
  
//           .arrow {
//             position: absolute;
//             top: 50%;
//             font-size: 20px;
//             background: none;
//             border: none;
//             cursor: pointer;
//           }
  
//           .next {
//             right: 0;
//           }
  
//           .prev {
//             left: 0;
//           }
//         </style>
//         <div class="card-slider">
//           <div class="cards-container">
//             <slot></slot>
//           </div>
//           <button class="arrow prev">←</button>
//           <button class="arrow next">→</button>
//         </div>
//       `;
  
//       shadowRoot.appendChild(template.content.cloneNode(true));
  
//       const cardsContainer = shadowRoot.querySelector('.cards-container');
//       const prevArrow = shadowRoot.querySelector('.arrow.prev');
//       const nextArrow = shadowRoot.querySelector('.arrow.next');
//       const cardWidth = shadowRoot.querySelector('.card').offsetWidth;
  
//       let currentIndex = 0;
  
//       function slideToIndex(index) {
//         const maxIndex = cardsContainer.children.length - 1;
//         currentIndex = Math.max(0, Math.min(index, maxIndex));
//         cardsContainer.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
//       }
  
//       prevArrow.addEventListener('click', () => {
//         slideToIndex(currentIndex - 1);
//       });
  
//       nextArrow.addEventListener('click', () => {
//         slideToIndex(currentIndex + 1);
//       });
//     }
//   }
  
//   customElements.define('custom-slider', CustomSlider);
  

// const slides = document.querySelectorAll('.slide');
// const dotsContainer = document.querySelector('.dots');

// const arrows = document.querySelectorAll('.arrow');
// let currentSlideIndex = 0;

// function showSlide(index) {
//   slides.forEach((slide, i) => {
//     slide.style.display = i === index ? 'block' : 'none';
//   });
//   updateActiveDot(index);
// }

// function updateActiveDot(index) {
//   const dots = document.querySelectorAll('.dot');
//   dots.forEach((dot, i) => {
//     dot.classList.toggle('active', i === index);
//   });
// }

// function createDots() {
//   slides.forEach((_, index) => {
//     const dot = document.createElement('span');
//     dot.className = 'dot';
//     dot.addEventListener('click', () => {
//       showSlide(index);
//       currentSlideIndex = index;
//     });
//     dotsContainer.appendChild(dot);
//   });
// }

// function nextSlide() {
//   currentSlideIndex = (currentSlideIndex + 1) % slides.length;
//   showSlide(currentSlideIndex);
// }

// function prevSlide() {
//   currentSlideIndex = (currentSlideIndex - 1 + slides.length) % slides.length;
//   showSlide(currentSlideIndex);
// }

// function handleTouchStart(event) {
//   touchStartX = event.touches[0].clientX;
// }

// function handleTouchEnd(event) {
//   const touchEndX = event.changedTouches[0].clientX;
//   const touchDiff = touchStartX - touchEndX;
  
//   if (touchDiff > 50) {
//     nextSlide();
//   } else if (touchDiff < -50) {
//     prevSlide();
//   }
// }

// arrows.forEach(arrow => {
//   arrow.addEventListener('click', () => {
//     if (arrow.classList.contains('prev')) {
//       prevSlide();
//     } else if (arrow.classList.contains('next')) {
//       nextSlide();
//     }
//   });
// });

// document.addEventListener('touchstart', handleTouchStart, false);
// document.addEventListener('touchend', handleTouchEnd, false);

// createDots();
// showSlide(currentSlideIndex);

// sadadada
const slider = document.querySelector('.slides');
const slideItem = document.querySelectorAll('.slide');
const prevArrow = document.querySelector('.arrow.prev');
const nextArrow = document.querySelector('.arrow.next');
const dotsContainer = document.querySelector('.dots');
// const dots = document.querySelectorAll('.dot');

let temp = '';

let currentIndex = 0;

function createDots() {
  return new Promise((resolve) => {
    slideItem.forEach(() => {
      const dotSpan = document.createElement('span');
      dotSpan.className = 'dot';
      // dot.addEventListener('click', () => {
      //   showSlide(index);
      //   currentSlideIndex = index;
      // });
      dotsContainer.appendChild(dotSpan);
    });
    resolve();
  })
}

createDots().then(() => {
  const dots = document.querySelectorAll('.dot');
  temp = dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentIndex = index;
      updateSlider();
    });
  });
}).then(updateDots)


slider.addEventListener('scroll', () => {
  const scrollPosition = slider.scrollLeft;
  currentIndex = Math.round(scrollPosition / slideItem[0].clientWidth); 
  updateDots();
});

prevArrow.addEventListener('click', () => {
  if (currentIndex > 0) {
    currentIndex--;
    updateSlider();
  }
});


nextArrow.addEventListener('click', () => {
  // console.log(currentIndex)
  if (currentIndex < slideItem.length -1) {
    currentIndex++;
    updateSlider();
  }
});


// dots.forEach((dot, index) => {
//   dot.addEventListener('click', () => {
//     currentIndex = index;
//     updateSlider();
//   });
// });

function updateSlider() {
  slider.scrollTo({
    left: currentIndex * slideItem[0].clientWidth,
    behavior: 'smooth'
  });
  updateDots();
}

function updateDots() {
  temp.forEach((dot, index) => {
    setTimeout( function() {
      dot.classList.toggle('active', index === currentIndex);
    }, 375)
  });
  // updateSlider();
}


